import Header from "../componentes/Header";

function Vests() {
    return(
        <Header/>
    )
}

export default Vests;